// eslint-disable-next-line no-restricted-imports
import { createTheme, responsiveFontSizes } from '@mui/material/styles';
import afb from './afb';
import ashcare from './ashcare';
import ch from './ch';
import internal from './internal';
import sf from './sf';

/**
 * Cannot just import typography if you want to access theme.palette AND we're overwriting the default of those. Otherwise theme.palette is not defined OR already defined with a different color. Even if using createTheme(oldTheme, {newTheme})
 */
import { typography, palette } from './styles';
import components from './components';

/**
 * Export the list of themes.
 * TODO: This is used in the storybook preview file for this project only, so maybe we move this out to a dev only file
 */
const themeList = [afb, ashcare, ch, internal, sf];

/**
 * This is the meat of the theme. The consuming React project imports this function and calls `getTheme('afd)` or another theme name.
 */
export default function getTheme(themeKey, themeMode = 'light') {
	// get the site theme based on what the consuming project asks for
	const siteThemeData = themeList.find(theme => theme.key === themeKey);
	if (!siteThemeData) {
		throw new Error(
			`The requested theme '${themeKey}' was not found, please check the list of supported site themes.`,
		);
	}

	const globalPalette = palette.getDesignTokens(themeMode);
	const sitePalette = siteThemeData.getDesignTokens(themeMode);

	const theme = createTheme({
		palette: {
			...globalPalette,
			...sitePalette,
		},
		/**
		 * Font family must be set in the initial theme creation or it will not apply to text within components
		 * if we add back a need to access site palette in typography
		 * a seperate object for typography will need to be added to the site theme creation below
		 */
		typography,
	});

	/**
	 * if accessing theme.palette, or theme.[any property] in typography, components, etc. it needs the palette (or whatever theme property) defined already
	 * if those get redefined at the site level, the new palette don't actually take effect
	 * demo: https://codesandbox.io/s/theme-palettes-o3qy0g?file=/demo.js
	 * demo with bug: https://codesandbox.io/s/theme-palettes-with-bug-xxoomv?file=/demo.js
	 * This is no longer used but can be added back see demo above for how
	 */

	const siteComponents = siteThemeData.components;

	/**
	 * Mixes in the global theme above with the individual pieces and site palette
	 */
	const siteTheme = createTheme(theme, {
		themeKey,
		components: {
			...components,
			...siteComponents,
		},
	});

	return responsiveFontSizes(siteTheme);
}

// Individual theme exports
export { themeList };
